import api from '../../common/api';
import url from '../../common/url';

export default {
    namespaced: true,
    state: {
        speciesList: [],
        isLoading: false,
        defaultSpecies: null,
    },
    mutations: {
        setDefaultSpecies(state, species) {
            state.defaultSpecies = species;
        },
        reset(state) {
            state.speciesList = [];
            state.isLoading = false;
        },
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        },
        addPage(state, page) {
            state.speciesList = [...state.speciesList, ...page.items];
        },
    },
    actions: {
        loadDefaultSpecies(context) {
            if (context.state.speciesList.length > 0) return;
            context.dispatch('loadSpecies', url.getSpeciesByRegion(context.rootState.session.country.id));
        },
        async loadSpecies(context, uri) {
            if (!uri) return;
            context.commit('setIsLoading', true);
            const page = await api.get(uri);
            context.commit('setIsLoading', false);
            if (page.error) return;
            context.commit('addPage', page);
            context.dispatch('loadSpecies', page.nextUri);
        },
        loadAllSpecies(context) {
            context.commit('reset');
            context.dispatch('loadSpecies', url.getSpecies());
        },
    },
};
